// extracted by mini-css-extract-plugin
export default {"btn":"SyncButton_btn__gt848","refresh":"SyncButton_refresh__LSPGL"};